import Api from '@/services/Api'

export default {
  // Método que llama a la url para crear un chat
 getCovidTraceList () {
   return Api().get("/covid-traces");
},
  updateCovidTrace (params) {
    return Api().put("/covid-traces",params);
  },
  addCovidTrace (params) {
    return Api().post("/covid-traces",params);
  },
  getCovidTrace (params) {
    return Api().get("/covid-traces/"+params);
  },
  getCovidTraceListByCovidId (params) {
    return Api().get("/covid-traces-by-covid/"+params);
  },
  getCovidTraceByToken (params) {
    return Api().get("/covid-trace-by-token/"+params);
  },
  deleteCovidTrace (params) {
    return Api().delete("/covid-traces/"+params);
  },

}



// WEBPACK FOOTER //
// ./src/services/CovidTracerService.js